import { useQuery } from '@tanstack/react-query';

import { OneOnOneSettingsPageReactQueryKeys } from '../constants/OneOnOneSettingsPageReactQueryKeys';
import { getOneOnOneSettingsPageData } from '../services';

export const useOneOnOneGeneralSettingsDetails = () =>
  useQuery(
    [
      OneOnOneSettingsPageReactQueryKeys.oneOnOneScoreEnabled,
      OneOnOneSettingsPageReactQueryKeys.includeTranscriptionBot,
    ],
    () => getOneOnOneSettingsPageData()
  );
